import { AddressInput } from '@rematter/frontend-lib-api-client';

import { useFacilitiesQuery } from '../useFacilitiesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useUpdateFacilityMutation = createMutationHook(
  'facilities.facilityUpdate',
  (params: {
    id: string;
    facilityName?: string;
    facilityType?: string;
    timezone?: string;
    address?: AddressInput;
    customAttributes?: Record<string, string | number | boolean | null>;
  }) => ({
    coreFacilityUpdate: {
      __args: {
        id: params.id,
        input: {
          facilityName: params.facilityName,
          facilityType: params.facilityType,
          timezone: params.timezone,
          address: params.address,
          customAttributes: params.customAttributes,
        },
      },
      id: true,
    },
  }),
  {
    invalidateQueries: [useFacilitiesQuery],
  },
);
